const apiAddress = (() => {

    let dynURL;
    if (typeof document != "undefined") {
        if ((dynURL = document.URL)) {
            if (dynURL.search(/lektuere-verstehen\.pons-mailservice/) >= 0)
                return "https://api-lektuere-verstehen.pons-mailservice.de";


            if (dynURL.search(/lektueren-verstehen\.de/) >= 0)
                return "https://api.lektueren-verstehen.de";
        }
    }
    return "http://localhost:3000";
})();

export default apiAddress;
